<template>
    <div>
        <v-toolbar class="glass rounded-lg" flat>
            <v-toolbar-title>
                Our Services
            </v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="600">
                <template v-slot:activator="{ on, attrs}">
                    <v-btn color="primary" v-on="on" v-bind="attrs">
                        Add New
                    </v-btn>
                </template>

                <v-form @submit.prevent="addEditTeam">
                    <v-card>
                        <v-card-title class="mb-3">
                            {{ formTitle }}
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-file-input
                                        v-model="form.preview_image"
                                        label="Member Image"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-camera"
                                        outlined
                                        class=""
                                        dense
                                        :error-messages="$page.props.errors.preview_image"
                                        accept="image/png, image/jpeg, image/bmp"
                                        persistent-hint
                                        :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                        hint="Only .jpg or .png are allowed"
                                    />
                                </v-col>
                                <v-col >
                                   <div class="text-center mt-n10 mb-2"  >
                                       <img
                                           :src="previewFile(form.preview_image)"
                                           height="100px"
                                           class="ml-1 "
                                           alt=""
                                       />
                                   </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="form.name"
                                        label="Member Name"
                                        :error-messages="$page.props.errors.name"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="form.position"
                                        label="Member Position"
                                        :error-messages="$page.props.errors.position"
                                    />
                                </v-col>
                            </v-row>
                            <v-textarea
                                rows="3"
                                outlined
                                dense
                                v-model="form.details"
                                :error-messages="$page.props.errors.details"
                                label="Member Details"
                            />

                            <v-row>
                                <v-col>
                                    <v-text-field
                                        prepend-inner-icon="mdi-facebook"
                                        outlined
                                        dense
                                        v-model="form.facebook"
                                        label="Facebook Profile"
                                    />
                                    <v-text-field
                                        prepend-inner-icon="mdi-twitter"
                                        outlined
                                        dense
                                        v-model="form.twitter"
                                        label="Facebook Twitter"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        prepend-inner-icon="mdi-instagram"
                                        outlined
                                        dense
                                        v-model="form.instagram"
                                        label="Facebook Instagram"
                                    />
                                    <v-text-field
                                        prepend-inner-icon="mdi-linkedin"
                                        outlined
                                        dense
                                        v-model="form.linkedin"
                                        label="Facebook Linkedin"
                                    />
                                </v-col>
                            </v-row>


                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn @click="close" depressed outlined color="warning" class="mx-1">
                                Cancel
                            </v-btn>

                            <v-btn type="submit" depressed   color="success" class="mx-1">
                                Submit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="$page.props.members"
                >
                    <template v-slot:item.icon="{ item }">
                        <img
                            :src="item.preview_image"
                            height="90px"
                            class="ml-1"
                            alt=""
                        />
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex">
                            <v-btn class="mx-1" small color="success" @click="editTeam(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn class="mx-1" small color="error" @click="deleteTeam(item)">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import AdminLayout from "../AdminLayout";
export default {
    name: "Index",
    layout:AdminLayout,
    data(){
        return {
            dialog:false,
            form:this.$inertia.form({
                id:null,
                name:null,
                position:null,
                preview_image:null,
                facebook:'#',
                twitter:'#',
                instagram:'#',
                linkedin:'#',
                details:null,
            }),
            headers:[
                {text:'Name', value:'name'},
                {text:'Image', value:'preview_image'},
                {text:'Position', value:'position'},
                {text:'Actions', value:'actions',sortable:false},
            ]
        }
    },

    computed:{

        formTitle(){

            if(this.form.id){
                return 'Edit '+this.form.title+ ' Team Member'
            }else{
                return 'New Team Member'
            }
        }
    },

    methods:{
        addEditTeam(){
            this.form.post(route('admin.teams.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },

        close(){
            this.form.reset()
            this.dialog = false
        },

        editTeam(team){
            this.form.id            = team.id
            this.form.name          = team.name
            this.form.position      = team.position
            this.form.preview_image = team.preview_image
            this.form.facebook      = team.facebook
            this.form.twitter       = team.twitter
            this.form.instagram     = team.instagram
            this.form.linkedin      = team.linkedin
            this.form.details       = team.details
            this.dialog = true
        },

        deleteTeam(team){
            Swal.fire({
                title: 'Are you sure?',
                text: ""+team.name+ " will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {

                    this.$inertia.delete(route('admin.teams.destroy',team.id),{
                        resetOnSuccess: false,
                        onSuccess: ()=>{
                            Toast.fire({
                                icon: 'success',
                                title: 'Member Deleted!'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
